var map = {
	"./img/andalucia/teaser_small.webp": 38108,
	"./img/basque-country/teaser_small.webp": 53993,
	"./img/berlin/teaser_small.webp": 84886,
	"./img/copenhagen/teaser_small.webp": 8496,
	"./img/portugal/teaser_small.webp": 86988,
	"./img/slovenia/teaser_small.webp": 94737,
	"./img/turkey/teaser_small.webp": 93034
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94999;